export default "__VITE_ASSET__mJpxAtn0__"